import { FormulationistDataProvider as DataProvider } from "./Formulationist.DataProvider";
import { FormulationistCore as Core } from "./Formulationist.Core";

// Core.whyDidYouRender = true;
// DataProvider.whyDidYouRender = true;
const Formulationist = { Core, DataProvider };
export default Formulationist;
